export default __webpack_public_path__ + "static/media/magicEdenLogo.356a3bbd.svg";